module.exports = __webpack_public_path__ + "img/57.923abc3d.jpg";